import { useMutation } from "@tanstack/react-query";
import Api from "src/Config";
import { createContext, FunctionComponent, ReactElement, useMemo } from "react";

export const AssignTransactionContext = createContext(null);

type Props = {
  children: ReactElement;
};

const AssignTransactionProvider: FunctionComponent<Props> = ({ children }) => {
  const { mutateAsync, data, isPending, error } = useMutation({
    mutationFn: async (payload: any) => {
      const data = await Api.post(
        `tm/transactions/${payload.id}/assign`,
        payload,
      );
      return data;
    },
    onError: (err) => {
      throw err;
    },
  });

  const contextValue = useMemo(
    () => ({
      mutateAsync,
      data,
      error,
      isPending,
    }),
    [mutateAsync, data, error, isPending],
  );
  return (
    <AssignTransactionContext.Provider value={contextValue}>
      {children}
    </AssignTransactionContext.Provider>
  );
};

export default AssignTransactionProvider;
